<div id="content" class="main-content">
    <div class="container">
        <div class="page-header ">
            <div class="page-title col-lg-12 col-md-12 col-sm-12 col-xs-12 justify-content-between ">
                <h2 class="col-sm-12 col-xs-12">
                    <i class="flaticon-menu-list"></i><b> Demandes</b>
                </h2>
            </div>
        </div>
        <div>

            <div class="row">
                <div class="col col-lg-12">
                    <div class="row" id="cancel-row" >
                        <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                            <div class="statbox widget box box-shadow">
                                <div class="widget-header">
                                    <div class="row">       
                                    </div>
                                </div>
                                <div class="widget-content widget-content-area pl-0 pr-1">
                                    <div *ngIf="ticketsLoading" class="cp-spinner cp-bubble" style="margin: auto; display: block; margin-top: 15%; margin-bottom: 15%;"></div>
                                    <div class="table-responsive mb-4" *ngIf="!ticketsLoading">
                                      <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                        <thead>
                                          <tr>
                                            <th>Référence</th>
                                            <th>Organisation</th>
                                            <th>Date/Heure</th>
                                            <th>Nom/Prénom</th>
                                            <th>Statut</th>
                                            <th>Ticket Jira</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr *ngFor="let ticket of alltickets">
                                            <td>
                                              <a [attr.href]="'ticket/detail/' + ticket.uuid" class="ref_ticket">
                                                <b>{{ ticket.ticketNumber }}</b>
                                              </a>
                                            </td>
                                            <td><b>{{ ticket.organisation || '- - -'}}</b></td>
                                            <td>{{ ticket.createdAt }}</td>
                                            <td>{{ ticket.creator || '- - -'}}</td>
                                            <td class="d-flex justify-content-center">
                                              <span class="mb-2 ml-2 badge badge-pills" style="font-size: xx-small;" [ngClass]="{'badge-open': ticket.status ==='Ouvert', 'badge-resolved' : ticket.status ==='Résolu', 'badge-reprised' : ticket.status ==='Repris', 'badge-inProgress' : ticket.status ==='En cours', 'badge-waiting' : ticket.status ==='En attente', 'badge-clos' : ticket.status ==='Clos'}">{{ ticket.status || '- - -' }}</span>
                                            </td>
                                            <td>
                                              <a [href]="'https://itimdex.atlassian.net/browse/' + ticket.jiraNumber" target="_blank">
                                                {{ ticket.jiraNumber || '- - -'}}
                                              </a>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                  
                            </div>    
                        </div>
                    </div>
                </div>
            </div>        
        </div>
    </div>
</div>